export enum Experiment {
  EnableSectionsTabInMobileAS = 'specs.membersAboutOOI.enableSectionsMobileAS',
  EnableOOIInEditor = 'specs.membersArea.framelessEditorProfilePage',
  RenderSEOTags = 'specs.membersAboutOOI.RenderSEOTags',
  EnableGeneralSettings = 'specs.membersArea.generalSettings',
  EnableGeneralSettingsViewer = 'specs.membersArea.generalSettingsViewer',
  UseErrorToast = 'specs.membersAboutOOI.UseErrorToasts',
  AboutPublishValidation = 'specs.about.MembersAboutSpecs$ValidateLinksInAboutContent',
  RateFromAppSettings = 'specs.membersArea.rateFromAppSettings',
}
